// extracted by mini-css-extract-plugin
export default {"title":"_1ojKB","breadcrumb":"_2M2yN"};